<script setup lang="ts">
    import KAutocomplete from "@/components/forms/inputs/Autocomplete/KAutocomplete.vue";
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { flashWarning } from "@/utils";
    import { getConfig, klinikenApi } from "@/api";
    import { convertPrioritetData, Prioritet } from "@/components/forms/reusables/prioritetHelper";

    const fetchPrio = async ({ query }: { query?: string } = {}) => {
        try {
            const response = await klinikenApi.get("operation/kodverk/prioriteter/", getConfig());

            return response.data.results.map((item: Prioritet) => convertPrioritetData({ prioritet: item }));
        } catch (error) {
            flashWarning("Kunde inte hämta språk");
        }
    };
</script>

<template>
    <KAutocomplete
        name="prio"
        label="Prioritet"
        v-bind="$attrs"
        :options="fetchPrio"
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
